import type { FC } from 'react';

import { SkeletonBlock } from '../../ui/SkeletonBlock';

export const SkeletonRow: FC = () => (
  <div className="flex items-center gap-2 h-[72px] py-4 pr-4 pl-2 animate-pulse">
    <div className="flex items-center justify-center size-8 shrink-0">
      <SkeletonBlock className="size-4" />
    </div>
    <div className="flex flex-col justify-center gap-2 min-w-0 flex-1">
      <SkeletonBlock className="h-4 w-[70%]" />
      <SkeletonBlock className="h-3 w-1/2" />
    </div>
    <SkeletonBlock className="h-3 shrink-0 w-[72px]" />
  </div>
);
